import { InPlaceUploadConnector, InPlaceUploadConnectorProps } from "./InPlaceUploadConnector";
import { BaseUploadData } from "./InPlaceUpload";
import { Container, StyledFormLabel, StyledFormHelperText } from "@kaltura/mediaspace-shared-ui";

interface InPlaceUploadFieldProps<DataT extends BaseUploadData = BaseUploadData>
    extends InPlaceUploadConnectorProps<DataT> {
    id: string;
    height: string;
    width: string;
    label: string;
    description: string;
    inline?: boolean;
}

/**
 * In-place upload wrapped in a form field style
 */
export const InPlaceUploadField = <DataT extends BaseUploadData>(props: InPlaceUploadFieldProps<DataT>) => {
    const { id, label, description, inline, ...rest } = props;

    return (
        <Container inline={inline}>
            <StyledFormLabel htmlFor={id} text={label} fontWeightBold={true} />
            <StyledFormHelperText>{description}</StyledFormHelperText>
            <InPlaceUploadConnector id={id} {...rest} />
        </Container>
    );
};
